import FormationBuilderPage from "../FormationBuilderPage";

const technicienMaintenanceIndustrielleAutomatismeProgram = [
  {
    title: "Électrotechnique : contacteurs, relais, disjoncteurs",
    img: "/assets/images/icon/light.svg",
  },
  {
    title: "Bases de l'automatisme : SAP, PO, PC, IHM",
    img: "/assets/images/icon/component-card.svg",
  },
  {
    title: "Programmation d'automates (Zelio Soft, Control Expert M221)",
    img: "/assets/images/icon/component-card.svg",
  },
  {
    title: "Langages Ladder / Grafcet / FBD / Littéral",
    img: "/assets/images/icon/component-card.svg",
  },
  {
    title: "IHM : Vijeo Designer",
    img: "/assets/images/icon/component-card.svg",
  },
  {
    title: "Réseaux industriels : Ethernet TCP/IP, Modbus",
    img: "/assets/images/icon/component-card.svg",
  },
  {
    title: "Création d'un dossier Machine complet (QElectroTech)",
    img: "/assets/images/icon/fiche.svg",
  },
  {
    title: "Pilotage et accès à distance des équipements",
    img: "/assets/images/icon/component-card.svg",
  },
  {
    title: "Méthodologie de diagnostic et dépannage",
    img: "/assets/images/icon/setting.svg",
  },
  { title: "Habilitation électrique", img: "/assets/images/icon/light.svg" },
  {
    title: "Câblage et lecture de plans électriques",
    img: "/assets/images/icon/light.svg",
  },
  {
    title: "Variation de vitesse et régulation",
    img: "/assets/images/icon/light.svg",
  },
  {
    title: "Amélioration continue : AMDEC, Pareto, 5S, TPM",
    img: "/assets/images/icon/redaction.svg",
  },
  {
    title: "Taux de défaillance MTBF / MTTR",
    img: "/assets/images/icon/setting.svg",
  },
  {
    title: "Pneumatique : FRL, distributeurs, effet Venturi",
    img: "/assets/images/icon/tuyaux.svg",
  },
  {
    title: "Mécanique 3D : cotation, tolérance, transmission de puissance",
    img: "/assets/images/icon/setting.svg",
  },
  {
    title: "Hydraulique : composants et maintenance des systèmes",
    img: "/assets/images/icon/tuyaux.svg",
  },
  {
    title: "Communication et présentation de ses compétences",
    img: "/assets/images/icon/work-women.svg",
  },
  {
    title: "Mise en situation : bancs d'essais réacteurs d'avion",
    img: "/assets/images/icon/rule.svg",
  },
  {
    title: "Soutenance de fin de cursus (dossier Machine)",
    img: "/assets/images/icon/fiche.svg",
  },
];

const TechnicienMaintenanceIndustrielleAutomatisme = () => (
  <FormationBuilderPage
    category="BTP-Tertiaire"
    titleColor="#2424FF"
    title="Technicien de Maintenance Industrielle Automatisme"
    duration={13}
    description={
      <p>
        Grâce au partenariat entre Liora et Vinci Facilities, rejoignez l'un des
        leaders français des services multi-techniques et de la performance
        énergétique des bâtiments en tant que Technicien de Maintenance
        Industrielle Automatisme, après une formation accélérée de 13 semaines.
        Performance énergétique des bâtiments, maintenance multi-technique,
        smart building, transition environnementale... rythment le quotidien de
        nos équipes, pourquoi pas le vôtre ?
      </p>
    }
    image="/assets/images/home/btp-tertiaire.png"
    formId="579c6f97-2c06-4ec0-ba1f-742922cc6853"
    popupFormId="5705be1e-3baf-4d49-9f13-541b1db0c861"
    program={technicienMaintenanceIndustrielleAutomatismeProgram}
  />
);

export default TechnicienMaintenanceIndustrielleAutomatisme;
